import { useMemo } from 'react';
import { t } from '../../../locale/texts';
import type { CarState } from '../carDefaultState';

export const useCarValidation = (state: Partial<CarState>, pristine: boolean) => {
    const invalid = useMemo(
        () => ({
            pickupLocation:
                !pristine &&
                (!(state.pickupLocationId || state.pickupLocation) || !(state.pickupLocationLatitude && state.pickupLocationLongitude)),

            returnLocation:
                !pristine &&
                !state.returnLocationIsSame &&
                (!(state.returnLocationId || state.returnLocation) || !(state.returnLocationLatitude && state.returnLocationLongitude)),

            pickupDate: !pristine && !state.pickupDate,
            pickupTime: !pristine && !state.pickupTime,
            returnDate: !pristine && !state.returnDate,
            returnTime: !pristine && !state.returnTime,
            driverAge: !pristine && !state.driverAge,
        }),
        [state, pristine],
    );

    const validationErrors = useMemo(
        () => ({
            pickupLocation: invalid.pickupLocation ? t('car.validation.pickupLocation') : null,
            returnLocation: invalid.returnLocation ? t('car.validation.returnLocation') : null,
            pickupDate: invalid.pickupDate ? t('car.validation.pickupDate') : null,
            returnDate: invalid.returnDate ? t('car.validation.returnDate') : null,
            pickupTime: invalid.pickupTime ? t('car.validation.pickupTime') : null,
            returnTime: invalid.returnTime ? t('car.validation.returnTime') : null,
            driverAge: invalid.driverAge ? t('car.validation.driverAge') : null,
        }),
        [invalid],
    );

    const getInvalidFields = (pristineOverride = pristine) => ({
        pickupLocation:
            !pristineOverride &&
            (!(state.pickupLocationId || state.pickupLocation) || !(state.pickupLocationLatitude && state.pickupLocationLongitude)),

        returnLocation:
            !pristineOverride &&
            !state.returnLocationIsSame &&
            (!(state.returnLocationId || state.returnLocation) || !(state.returnLocationLatitude && state.returnLocationLongitude)),

        pickupDate: !pristineOverride && !state.pickupDate,
        pickupTime: !pristineOverride && !state.pickupTime,
        returnDate: !pristineOverride && !state.returnDate,
        returnTime: !pristineOverride && !state.returnTime,
        driverAge: !pristineOverride && !state.driverAge,
    });

    return {
        invalid,
        validationErrors,
        getInvalidFields,
    };
};
